import $ from 'jquery';
import _ from 'lodash';
import LazyLoad from 'vanilla-lazyload';

window.$        = $;
window.jQuery   = $;
window._        = _;
window.LazyLoad = LazyLoad;

require('jquery-inview');
require('jquery-lazyload');



// WEBPACK FOOTER //
// ./src/vendors-lite.js